<div class="container-fluid anim-loading">
  <div class="page-title page-title--columns">
    <div class="page-title__left"><h2 i18n>Motivos de Invalidação</h2></div>
    <div class="page-title__right" *appPermission="'CreateReason'">
      <button i18n type="button" class="btn btn-fade-primary mr-2"
        title="Cadastrar Motivo de Invalidação"
        (click)="openCreateOrUpdateReason()">Novo Motivo de Invalidação</button>
      <button i18n type="button" class="btn btn-fade-primary"
        title="Replicar Motivo de Invalidação"
        (click)="openReplicateReason()">Replicar Motivo de Invalidação</button>
    </div>
  </div>
  <div class="mb-4">
    <form [formGroup]="searchForm" (submit)="handleSearch()">
      <div class="input-group">
        <input type="text" class="form-control form-search"
          formControlName="search" i18n-placeholder
          placeholder="Buscar registro" (ngModelChange)="searchKey($event)"
          autocomplete="off">
      </div>
    </form>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card mb-3" *ngFor="let contractCard of contractCardsPaged">
        <div class="card-body">
          <h5 class="card-title"
            (click)="contractCard.isOpen = !contractCard.isOpen"
            style="cursor: pointer;">
            {{ contractCard.contractCode }} - {{ contractCard.contractName }}
            <i class="material-icons float-right">
              {{ contractCard.isOpen ? 'expand_less' : 'expand_more' }}
            </i>
          </h5>
          <div *ngIf="contractCard.isOpen">
            <div class="table-responsive table-hover table-block">
              <table class="table bg-white">
                <thead class="bg-header-table">
                  <tr>
                    <th i18n *appPermission="'UpdateReason'">Habilitado</th>
                    <th i18n class="text-center">Contrato</th>
                    <th i18n class="text-center">
                      <p class="d-flex align-items-center mt-3">
                        <span>Código</span>
                        <i class="material-icons btn-sort"
                          title="Ordenar pelo código"
                          (click)="sortReasonsByCode(contractCard)">swap_vert</i>
                      </p>
                    </th>
                    <th i18n class="col-3 text-center">
                      <p class="d-flex align-items-center mt-3">
                        <span>Nome</span>
                        <i class="material-icons btn-sort"
                          title="Ordenar pelo nome"
                          (click)="sorteReasonsByName(contractCard)">swap_vert</i>
                      </p>
                    </th>
                    <th i18n class="text-center">Enquadramentos</th>
                    <th i18n class="text-center">Tipo</th>
                    <th i18n class="text-center">Módulos</th>
                    <th i18n class="text-center">Telas</th>
                    <th i18n *appPermission="['UpdateReason','DeleteReason']"
                      class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let reason of contractCard.reasonsPaged">
                    <td *appPermission="'UpdateReason'">
                      <div class="custom-control custom-switch mt-2">
                        <div class="form-group">
                          <label class="custom-control-label"
                            [ngClass]="{checked:reason.enabled}">
                            <input type="checkbox"
                              class="form-control custom-control-input"
                              *appPermission="'UpdateReason'; contracts reason.contractId"
                              [(ngModel)]="reason.enabled"
                              (change)="updateReasonEdit(reason)">
                          </label>
                        </div>
                      </div>
                    </td>
                    <td [appTooltip]="contractCard?.contractName"
                      (click)="openReasonView(reason)">
                      {{ contractCard?.contractCode }}
                    </td>
                    <td class="text-center"
                      (click)="openReasonView(reason)">
                      {{reason.code}} <br />
                      <em>{{ reason.clientCode || '-' }}</em>
                    </td>
                    <td class="text-center"
                      (click)="openReasonView(reason)">{{reason.name ||
                      '-'}}</td>
                    <td (click)="openReasonView(reason)">
                      <div
                        *ngFor="let regulationId of reason.regulationIds; let i= index"
                        class="badge badge-secondary mr-1">
                        <div *ngIf="i===1; else onlyRegulation">
                          <i *ngIf="regulationById[regulationId]"
                            i18n-appTooltip
                            appTooltip="{{regulationById[regulationId].description || ''}}">
                            {{ regulationById[regulationId]?.code + '...' }}
                          </i>
                        </div>
                        <ng-template #onlyRegulation>
                          <i *ngIf="regulationById[regulationId] && i===0"
                            i18n-appTooltip
                            appTooltip="{{regulationById[regulationId].description || ''}}">
                            {{ regulationById[regulationId]?.code }}
                          </i>
                        </ng-template>
                      </div>
                    </td>
                    <td class="text-center"
                      (click)="openReasonView(reason)">{{reason.type ||
                      '-'}}</td>
                    <!-- módulos -->
                    <td (click)="openReasonView(reason)">
                      <div *ngIf="reason?.screen?.length > 0; else noItens">
                        <span *ngFor="let screen of reason.screen.slice(0,6)"
                          class="badge badge-secondary mr-1">
                          {{ stepModesLabel(screen) + '' }}
                        </span>
                        <a *ngIf="reason?.screen?.length > 6"
                          class="badge badge-secondary">...</a>
                      </div>
                    </td>
                    <td (click)="openReasonView(reason)">
                      <div *ngIf="reason?.screen?.length > 0; else noItens">
                        <span *ngFor="let screen of reason.screen.slice(0,6)"
                          class="badge badge-secondary mr-1">
                          {{ stepModesLabel(screen) + '' }}
                        </span>
                        <a *ngIf="reason?.screen?.length > 6"
                          class="badge badge-secondary">...</a>
                      </div>
                    </td>
                    <td class="text-center"
                      *appPermission="['UpdateReason','DeleteReason']; contracts reason.contractId">
                      <button type="button"
                        class="btn text-secondary btn-icon-block"
                        data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i class="material-icons">more_horiz</i>
                      </button>
                      <div class="dropdown-menu"
                        aria-labelledby="btnGroupDrop4">
                        <a class="dropdown-item"
                          (click)="openCreateOrUpdateReason(reason)" i18n
                          *appPermission="['UpdateReason']; contracts reason.contractId">
                          Editar Motivo
                        </a>
                        <a class="dropdown-item"
                          (click)="openDeleteModal(reason)"
                          i18n
                          *appPermission="['DeleteReason']; contracts reason.contractId">
                          Remover Motivo
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination-simple
              (items)="contractCard.reasonsPaged = $event"
              [data]="contractCard.reasons">
            </app-pagination-simple>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 d-flex justify-content-center">
      <app-pagination-simple
        *ngIf="!loading; else loadingComponent"
        (items)="contractCardsPaged = $event"
        [data]="contractCards">
      </app-pagination-simple>
      <ng-template #loadingComponent>
        <app-loading [load]="loading"></app-loading>
      </ng-template>
    </div>

    <!--
    <div class="mt-5 mb-3">
      <div class="table-responsive table-hover table-block">
        <table class="table bg-white">
          <thead class="bg-header-table">
            <tr>
              <th i18n *appPermission="'UpdateReason'">Habilitado</th>
              <th i18n class="text-center">Contrato</th>
              <th i18n class="text-center">Código</th>
              <th i18n class="text-center">Código do Cliente</th>
              <th i18n class="col-3 text-center">Nome</th>
              <th i18n class="text-center">Enquadramentos</th>
              <th i18n class="text-center">Tipo</th>
              <th i18n class="text-center">Telas</th>
              <th i18n *appPermission="['UpdateReason','DeleteReason']"
                class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let reason of reasons">
              <td *appPermission="'UpdateReason'">
                <div class="custom-control custom-switch mt-2">
                  <div class="form-group">
                    <label class="custom-control-label"
                      [ngClass]="{checked:reason.enabled}">
                      <input type="checkbox"
                        class="form-control custom-control-input"
                        *appPermission="'UpdateReason'; contracts reason.contractId"
                        [(ngModel)]="reason.enabled"
                        (change)="updateReasonEdit(reason)">
                    </label>
                  </div>
                </div>
              </td>
              <td [appTooltip]="contracts[reason.contractId]?.name"
                (click)="openReasonView(reason)">
                {{ contracts[reason.contractId] &&
                contracts[reason.contractId].code }}
              </td>
              <td class="text-center"
                (click)="openReasonView(reason)">
                {{reason.code}}
              </td>
              <td class="text-center"
                (click)="openReasonView(reason)">
                {{ reason.clientCode || '-' }}
              </td>
              <td class="text-center"
                (click)="openReasonView(reason)">{{reason.name || '-'}}</td>
              <td (click)="openReasonView(reason)">
                <div
                  *ngFor="let regulationId of reason.regulationIds; let i= index"
                  class="badge badge-secondary mr-1">
                  <div *ngIf="i===1; else onlyRegulation">
                    <i *ngIf="regulationById[regulationId]" i18n-appTooltip
                      appTooltip="{{regulationById[regulationId].description || ''}}">
                      {{ regulationById[regulationId]?.code + '...' }}
                    </i>
                  </div>
                  <ng-template #onlyRegulation>
                    <i *ngIf="regulationById[regulationId] && i===0"
                      i18n-appTooltip
                      appTooltip="{{regulationById[regulationId].description || ''}}">
                      {{ regulationById[regulationId]?.code }}
                    </i>
                  </ng-template>
                </div>
              </td>
              <td class="text-center"
                (click)="openReasonView(reason)">{{reason.type || '-'}}</td>
              <td (click)="openReasonView(reason)">
                <div *ngIf="reason?.screen?.length > 0; else noItens">
                  <span *ngFor="let screen of reason.screen.slice(0,6)"
                    class="badge badge-secondary mr-1">
                    {{ stepModesLabel(screen) + '' }}
                  </span>
                  <a *ngIf="reason?.screen?.length > 6"
                    class="badge badge-secondary">...</a>
                </div>
              </td>
              <td class="text-center"
                *appPermission="['UpdateReason','DeleteReason']; contracts reason.contractId">
                <button type="button" class="btn text-secondary btn-icon-block"
                  data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="material-icons">more_horiz</i>
                </button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop4">
                  <a class="dropdown-item"
                    (click)="openCreateOrUpdateReason(reason)" i18n
                    *appPermission="['UpdateReason']; contracts reason.contractId">
                    Editar Motivo
                  </a>
                  <a class="dropdown-item" (click)="openDeleteModal(reason)"
                    i18n
                    *appPermission="['DeleteReason']; contracts reason.contractId">
                    Remover Motivo
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <app-pagination (items)="setReasons($event)" [params]="params"
      [deleteEvent]="deleteEvent" [service]="reasonService"
      [permission]="'ViewReason'">
    </app-pagination>
    -->

  </div>
</div>
